// Compact count formatting for admin stat cards (single source of truth -- the
// backend always returns exact integers; display is purely a frontend concern).
//
//   0 .. 999            -> exact            (999      -> "999")
//   1,000 .. 999,999    -> thousands, 2 dp  (1250     -> "1.25k")
//   1,000,000 ..        -> millions, 2 dp   (2500000  -> "2.50M")
//   1,000,000,000 ..    -> billions, 2 dp   (no larger unit; 1.5e12 -> "1500.00B")
//
// Rounds half-up to 2 decimals, and if rounding reaches 1000 of a unit it rolls to
// the next unit (999,999 -> "1.00M", never "1000.00k"). Rounding uses integer
// hundredths (n * 100 / divisor), not toFixed() on a float quotient, so values like
// 1005 round to "1.01k" rather than suffering binary-float error ("1.00k").

const UNITS = [
  { divisor: 1e9, suffix: 'B' },
  { divisor: 1e6, suffix: 'M' },
  { divisor: 1e3, suffix: 'k' },
];

export function formatCount(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0';
  const sign = n < 0 ? '-' : '';
  const abs = Math.round(Math.abs(n)); // counts are integers; guard against stray floats
  if (abs < 1000) return `${sign}${abs}`;

  // Smallest unit first (k, M, B); step up while rounding would print >= 1000.
  for (let i = UNITS.length - 1; i >= 0; i -= 1) {
    const { divisor, suffix } = UNITS[i];
    const hundredths = Math.round((abs * 100) / divisor);
    if (hundredths < 100000 || i === 0) {
      return `${sign}${(hundredths / 100).toFixed(2)}${suffix}`;
    }
  }
  return `${sign}${abs}`; // unreachable
}

// Exact value with thousands separators, for the hover tooltip.
export function formatExactCount(value) {
  const n = Number(value);
  return Number.isFinite(n) ? Math.round(n).toLocaleString('en-US') : '0';
}
